import { inject, Injectable } from '@angular/core';
import {
  HttpClient,
  HttpParams,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { GlobalApiResponse } from '../../../features/salarie/pages/career-evaluation/models/api.types';

export interface StatutPaieResponse {
  organisationId: string;
  mois: number;
  annee: number;
  periodeExiste: boolean;

  statutPaie: string | null;
  clotureDemandable: boolean;

  modeCloture: string | null;

  dateDemandeCloture: string | null;
  dateLimiteCloture: string | null;
  dateCloture: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class PayrollPeriodAlertService {

  private readonly http = inject(HttpClient);

  private readonly baseUrl =
    `${environment.gatewayUrl}/paie/api/v1/paie`;

  getStatutPaie(
    organisationId: string,
    mois: number | null = null,
    annee: number | null = null,
  ): Observable<GlobalApiResponse<StatutPaieResponse>> {

    let params = new HttpParams();

    if (mois !== null) {
      params = params.set(
        'mois',
        mois.toString(),
      );
    }

    if (annee !== null) {
      params = params.set(
        'annee',
        annee.toString(),
      );
    }

    return this.http.get<
      GlobalApiResponse<StatutPaieResponse>
    >(
      `${this.baseUrl}/statut/${organisationId}`,
      {
        params,
      },
    );
  }
}